import { getEnv, VUE_APP_EDGE_SERVER } from '#/utils/env';

const edgeUrl = getEnv(VUE_APP_EDGE_SERVER);
console.log('edge url: ', edgeUrl);

const { ServiceQueryAccountClient, ServiceModifyAccountClient } = require('#/protobuf/service_account_grpc_web_pb');
const { ServiceQueryUserClient, ServiceUpdateUserClient, ServiceVerifyUserClient } = require('#/protobuf/service_user_grpc_web_pb');
const { ServiceQueryProjectClient } = require('#/protobuf/service_query_grpc_web_pb');
const { ServiceModifyProjectClient, ServiceCommentingClient } = require('#/protobuf/service_modification_grpc_web_pb');
const { ServiceProjectDataDeletionClient } = require('#/protobuf/service_deletion_grpc_web_pb');
const { ServiceBillingClient } = require('#/protobuf/service_billing_grpc_web_pb');
const { ServiceLiveSubscribeClient } = require('#/protobuf/service_live_subscriber_grpc_web_pb');
const { ServiceIngestClient } = require('#/protobuf/service_ingest_grpc_web_pb');

export const queryAccountClient = new ServiceQueryAccountClient(edgeUrl);
export const modifyAccountClient = new ServiceModifyAccountClient(edgeUrl);
export const queryUserClient = new ServiceQueryUserClient(edgeUrl);
export const modifyUserClient = new ServiceUpdateUserClient(edgeUrl);
export const verifyUserClient = new ServiceVerifyUserClient(edgeUrl);
export const queryProjectClient = new ServiceQueryProjectClient(edgeUrl);
export const modifyClient = new ServiceModifyProjectClient(edgeUrl);
export const commentClient = new ServiceCommentingClient(edgeUrl);
export const deletionClient = new ServiceProjectDataDeletionClient(edgeUrl);
export const billingClient = new ServiceBillingClient(edgeUrl);
export const liveClient = new ServiceLiveSubscribeClient(edgeUrl);
export const ingestClient = new ServiceIngestClient(edgeUrl);
